goog.provide("shadow.js.shim.module$material_ui_popup_state$hooks");
goog.provide("module$shadow_js_shim_module$material_ui_popup_state$hooks");
shadow.js.shim.module$material_ui_popup_state$hooks = shadow.js.nativeProvides["material-ui-popup-state/hooks"] = shadow$bridge("material-ui-popup-state/hooks");
module$shadow_js_shim_module$material_ui_popup_state$hooks.default = shadow.js.shim.module$material_ui_popup_state$hooks;
